<template>
  <v-dialog v-model="showPaymentDialog" width="700px">
    <section>
      <html2Pdf ref="vuepdf">
        <v-card class="padd-5" width="750px">
          <v-row>
            <v-col class="d-flex Justify-center" cols="4">
              <img
                src="@/assets/master_logo.png"
                width="170"
                height="80"
                contain
                class="mt-3 ms-5"
              />
            </v-col>
            <v-col class="ma-3">
              <p class="mb-0 pb-0">
                <b> QQ Pay Sdn. Bhd.</b>
              </p>
              <p class="mb-0 mt-0 address-font">
                <br />
                Level 20, Menara 1 Sentrum, 201, Jalan Tun Sambanthan,
                Brickfields,50470 Kuala Lumpur, Wilayah Persekutuan Kuala Lumpur
              </p>
            </v-col>
          </v-row>
          <v-card
            outlined
            tile
            height="30px"
            class="mt-5 border-rounded title-card-bg-color"
          >
            <div class="white--text text-center text-h6">RECEIPT</div>
          </v-card>
          <span v-if="val === 'payIn'">
            <v-card
              outlined
              tile
              class="mt-1 padd-3 border-rounded font-text card-bg-color"
            >
              <h6>Payment Details:</h6>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2">
                  Transaction ID/ Receipt No
                </v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>
                  {{ txnDetail.pin_umber ? txnDetail.pin_umber : "" }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2">Amount</v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>$
                  {{ txnDetail.transfer_amt ? txnDetail.transfer_amt : "" }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Txn Date</v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>
                  {{
                    paymentData.remarks_data &&
                    paymentData.remarks_data.modified_date
                      ? paymentData.remarks_data.modified_date
                      : ""
                  }}
                </v-col>
              </v-row>
              <!-- <v-row no-gutters>
                <v-col cols="5" class="ps-2"> IS Gst </v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>fgfvfgfr
                </v-col>
              </v-row> -->
              <!-- <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Remarks</v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span
                  >{{ paymentData.remarks_data.remarks }}
                </v-col>
              </v-row> -->
            </v-card>
            <v-card
              outlined
              tile
              class="mt-1 padd-3 border-rounded font-text card-bg-color"
            >
              <h6>Sender Details:</h6>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2">Sender Name </v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span
                  >{{
                    senderData.middle_name
                      ? senderData.first_name +
                        " " +
                        senderData.middle_name +
                        " " +
                        senderData.last_name
                      : senderData.last_name
                      ? senderData.first_name + " " + senderData.last_name
                      : senderData.first_name
                  }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Contact Number</v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>{{ senderData.mobile }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Address</v-col>
                <v-col cols="7" class="d-flex">
                  <span class="paddleft-2">:</span>
                  <div>{{ senderData.address ? senderData.address : "" }}</div>
                </v-col>
              </v-row></v-card
            >
          </span>

          <span v-if="val === 'payout'">
            <v-card
              outlined
              tile
              class="mt-1 padd-3 border-rounded font-text card-bg-color"
            >
              <h6>Payment Details:</h6>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2">
                  Transaction ID/ Receipt No
                </v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>
                  {{ txnDetail.pin_umber ? txnDetail.pin_umber : "" }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Date </v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>
                  {{
                    paymentData.remarks_data &&
                    paymentData.remarks_data.modified_date
                      ? paymentData.remarks_data.modified_date
                      : ""
                  }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Send Amount </v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span> $
                  {{ txnDetail.transfer_amt?txnDetail.transfer_amt:"" }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Remarks</v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span
                  >{{
                    paymentData.remarks_data && paymentData.remarks_data.remarks
                      ? paymentData.remarks_data.remarks
                      : ""
                  }}
                </v-col>
              </v-row>
            </v-card>
            <v-card
              outlined
              tile
              class="mt-1 padd-3 border-rounded font-text card-bg-color"
            >
              <h6>Sender Details:</h6>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2">Sender Name </v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span
                  >{{
                    senderData.middle_name
                      ? senderData.first_name +
                        " " +
                        senderData.middle_name +
                        " " +
                        senderData.last_name
                      : senderData.last_name
                      ? senderData.first_name + " " + senderData.last_name
                      : senderData.first_name
                  }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Contact Number</v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>{{ senderData.mobile }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Address</v-col>
                <v-col cols="7" class="d-flex">
                  <span class="paddleft-2">:</span>
                  <div>
                    {{
                      senderData.address && senderData.address
                        ? senderData.address
                        : ""
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
            <v-card
              outlined
              tile
              class="mt-1 padd-3 border-rounded font-text card-bg-color"
            >
              <h6>Payout Details:</h6>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Payout Name </v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>
                  {{ receiverData.full_name ? receiverData.full_name : "" }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2">Address </v-col>
                <v-col cols="7" class="d-flex">
                  <span class="paddleft-2">:</span>
                  <div class="ms-1">
                    {{ receiverData.address ? receiverData.address : "" }}
                  </div>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Email </v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>
                  {{ receiverData.email ? receiverData.email : "" }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2"> Mobile</v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>
                  {{ receiverData.mobile ? receiverData.mobile : "" }}
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5" class="ps-2">Pay Id/Account Number </v-col>
                <v-col cols="7">
                  <span class="paddleft-2">:</span>
                  {{ receiverData.ac_number ? receiverData.ac_number : "" }}
                </v-col>
              </v-row>
            </v-card>
          </span>
          <v-col class="address-font">
            <div class="ps-2 pt-2 pb-0 text-grey">
              1.It is the sender's responsibility to notify the beneficiary on
              the Receiving Amount
            </div>
            <div class="ps-2 pt-2 pb-0 text-grey">
              2.It is the sender's responsibility to provide accurate
              information to facilitate successful remittance payout
            </div>
            <div class="ps-2 pt-2 pb-0 text-grey">
              3.This is a computer generated receipt and no signature is
              required
            </div>
          </v-col>
        </v-card>
      </html2Pdf>
    </section>
  </v-dialog>
</template>
<script>
import html2Pdf from "./vue-html-pdf.vue";
export default {
  emits: ["close-dialog"],
  components: {
    html2Pdf,
  },
  mounted() {
    this.dialogVisible = this.showPaymentDialog;
    console.log(this.receiverData);
    console.log("receipt dialog");
    console.log(this.val);
    console.log(this.showPaymentDialog);
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  watch: {
    showPaymentDialog(val) {
      console.log(val);
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit("close-dialog");
      }
    },
  },
  props: [
    "receiverData",
    "showPaymentDialog",
    "senderData",
    "txnDetail",
    "val",
    "paymentData",
  ],
};
</script>
<style lang="scss" scoped>
.font-text {
  font-size: 15px !important;
  line-height: 26px;
}
.address-font {
  font-size: 13px;
}
.paddleft-2 {
  padding-right: 10px;
}
.text-grey {
  color: grey;
}
.card-bg-color {
  background-color: rgb(245, 245, 245) !important;
  border-radius: 4px !important;
  border: none;
}
.title-card-bg-color {
  background-color: #ff6b00 !important;
  border-radius: 4px !important;
}
.padd-3 {
  padding: 10px;
}
.padd-5 {
  padding: 15px;
}
</style>
